import React, { Fragment } from 'react';

// Components

import SummaryItem from '../SummaryItem';

// Utils

import { normalizeNameOfPerson } from '@utils/normalize/normalizeNameOfPerson';
import { phoneNumberTools } from '@utils/tools/phoneNumberTools';
import { NO_PRIOR_DATA } from '@constants/ssap/miscellaneous/miscellaneous';



const EmergencyContactInfo = props => {
    const {
        emergencyContactInfo: {
            name,
            name: {
                firstName,
                lastName
            },
            phone: {
                phoneNumber
            },
            emailAddress
        },
        pcpIndex
    } = props;

    const getPersonName = (name, isPrevious = false) => {
        if ((name.firstName === null || name.lastName === null) && isPrevious) {
            return NO_PRIOR_DATA;
        }

        return normalizeNameOfPerson(name);
    };

    return (
        <Fragment>
            {
                (firstName && lastName) &&

                <SummaryItem
                    textCode = 'ssap.final_review.emergency_contact_name'
                    value = { getPersonName(name) }
                    ignoreIntl

                    desc = {
                        [
                            [
                                `taxHousehold.householdMember[${ pcpIndex }].emergencyContactInfo.name`,
                                getPersonName,
                                [ true ]
                            ]
                        ]
                    }
                />
            }
            {
                phoneNumber &&

                <SummaryItem
                    textCode = 'ssap.final_review.emergency_contact_phone_home'
                    value = { phoneNumberTools.getAdjustedPhoneNumber(phoneNumber) }
                    ignoreIntl
                    noPriorDataValues = { [ null, '' ] }
                    desc = {
                        [
                            [
                                `taxHousehold.householdMember[${ pcpIndex }].emergencyContactInfo.phone.phoneNumber`,
                                phoneNumberTools.getAdjustedPhoneNumber
                            ]
                        ]
                    }
                />
            }
            {
                emailAddress &&

                <SummaryItem
                    textCode = 'ssap.final_review.emergency_contact_email_address'
                    value = { emailAddress }
                    ignoreIntl
                    noPriorDataValues = { [ null ] }
                    desc = {
                        [
                            [
                                `taxHousehold.householdMember[${ pcpIndex }].emergencyContactInfo.emailAddress`
                            ]
                        ]
                    }
                />
            }
        </Fragment>
    );
};

export default EmergencyContactInfo;